var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-loading',{attrs:{"loading":_vm.integrationMeta.loading}},[_c('integration-form',{attrs:{"mode":"edit","integration":_vm.integration},on:{"submit":_vm.handleSubmit,"delete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }